import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AuthFlowManager from "./AuthFlowManager";

interface FormSignupProps {
    prefillEmail?: string;
    onEmailChange?: (email: string) => void;
}

const FormSignup: React.FC<FormSignupProps> = React.memo(({ prefillEmail, onEmailChange }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                flex: 1,
                minHeight: 0 // Allows flex children to shrink below content size
            }}
        >
            {/* Header - Pinned at top */}
            <Box
                sx={{
                    flexShrink: 0,
                    pb: 2
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Create Account
                </Typography>
            </Box>

            {/* Form content - Scrollable area with spacing from header */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    pt: 2,
                    pb: 4
                }}
            >
                <AuthFlowManager
                    flowType="signup"
                    prefillEmail={prefillEmail}
                    onEmailChange={onEmailChange}
                    onStepTransition={(step, error, data) => {
                        // Handle step transitions for signup flow
                    }}
                    initialStepConfig={{
                        signup: 'enabled',
                        verifyEmail: 'hidden',
                        passwordConfirmation: 'hidden',
                        setupMFA: 'hidden',
                        verifyMFA: 'hidden'
                    }}
                />
            </Box>
        </Box>
    );
});

FormSignup.displayName = 'FormSignup';

export default FormSignup;
